import React from 'react';
import {Checkbox, Drawer, Grid, Table, TableBody, TableCell, TableHead, TableRow, withStyles} from "material-ui";
import {connect} from "react-redux";
import {closeRegulationFilterDrawer} from "../../../redux/actions/drawer";
import {setFilterRegulation} from "../../../redux/actions/filter";

export class FilterDrawer extends React.Component {

    state = {
        status: [false, false, false],
    };

    componentDidMount = () => {
        this.setState({status: this.props.filter.status});
    };

    handleCheckBox = (index) => {
        let _filter = this.props.filter;
        _filter.status[index] = !this.props.filter.status[index];
        this.setState({status: _filter.status});
        this.props.setFilterRegulation(_filter);
    };

    handleClose = () => {
        this.props.closeRegulationFilterDrawer();
        this.props.handleClose();
    };

    render() {

        const {classes, isOpen} = this.props;
        const {status} = this.state;

        const statuses = ['未対応', '適正', '不適正'];

        return (
            <Drawer
                anchor="right"
                open={isOpen}
                onClose={this.handleClose}>
                <div className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>フィルター</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {statuses.map((n, i) => {
                                return <TableRow key={i}>
                                    <TableCell>
                                        <Grid container alignItems="center">
                                            <Grid item>
                                                <Checkbox
                                                    onClick={this.handleCheckBox.bind(this, i)}
                                                    checked={status[i]}/>
                                            </Grid>
                                            <Grid item>{n}</Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            })}

                        </TableBody>
                    </Table>
                </div>
            </Drawer>
        )
    }
}

const styles = theme => ({
    root: {
        width: 300,
    },
    clickRow: {
        cursor: 'pointer',
    },
});

FilterDrawer = withStyles(styles)(FilterDrawer);

FilterDrawer = connect(
    (state) => {
        return {
            isOpen: state.drawer.isOpenRegulationFilterDrawer,
            filter: state.filter.regulation,
        }
    },
    (dispatch) => {
        return {
            closeRegulationFilterDrawer: () => {
                dispatch(closeRegulationFilterDrawer());
            },
            setFilterRegulation: (filter) => {
                dispatch(setFilterRegulation(filter));
            },
        }
    }
)(FilterDrawer);


// WEBPACK FOOTER //
// ./src/containers/regulation/drawer/filter.js